import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import ArticleDetail from '../views/ArticleDetail.vue'
import AuthPage from '../views/AuthPage.vue'
import AdminLogin from '../views/admin/AdminLogin.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import ArticleEditor from '../views/admin/ArticleEditor.vue'
import CategoryManagement from '../views/admin/CategoryManagement.vue'
import TagManagement from '../views/admin/TagManagement.vue'
import ArticleManagement from '../views/admin/ArticleManagement.vue'
// import authService from '../services/authService.js'
import supabaseAuthService from '../services/supabaseAuthService.js'
import ArticleBrowse from '../views/ArticleBrowse.vue'


const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/browse',
        name: 'ArticleBrowse',
        component: ArticleBrowse
    },
    {
        path: '/article/:id',
        name: 'ArticleDetail',
        component: ArticleDetail,
        props: true
    },
    {
        path: '/auth',
        name: 'Auth',
        component: AuthPage
    },
    {
        path: '/login',
        redirect: '/auth'
    },
    {
        path: '/register',
        redirect: { path: '/auth', query: { mode: 'register' } }
    },

    {
        path: '/admin',
        name: 'AdminLogin',
        component: AdminLogin
    },
    {
        path: '/admin/dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/article/new',
        name: 'NewArticle',
        component: ArticleEditor,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/article/edit/:id',
        name: 'EditArticle',
        component: ArticleEditor,
        props: true,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/categories',
        name: 'CategoryManagement',
        component: CategoryManagement,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/tags',
        name: 'TagManagement',
        component: TagManagement,
        meta: { requiresAuth: true }
    },
    {
        path: '/admin/articles',
        name: 'ArticleManagement',
        component: ArticleManagement,
        meta: { requiresAuth: true }
    }
]

// 生产环境使用 Hash 路由，避免静态托管/直接打开 dist/index.html 时出现空白
const history = import.meta.env.MODE === 'production'
    ? createWebHashHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL)

const router = createRouter({
    history,
    routes
})

// 路由守卫 - 保护需要认证的路由（基于 Supabase）
router.beforeEach(async (to, from, next) => {
    // 管理员路由保护
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const session = await supabaseAuthService.getSession()
        if (!session) {
            next('/admin')
            return
        }
        const isAdmin = await supabaseAuthService.ensureAdmin()
        if (!isAdmin) {
            next('/admin')
            return
        }
    }



    next()
})

export default router 